<template>
    <or-layout>
        <div>
            <div>
                <a-row>

                    <a-col :span="4">
                        <a-select :v-model="grade_id" default-value="0" style="width: 120px" @change="handleChangegrade">
                            <a-select-option value="0">
                                全部年级
                            </a-select-option>
                            <a-select-option v-for="grade in gradelist" :key="grade.id">
                                {{ grade.name }}
                            </a-select-option>
                        </a-select>
                        <a-select :v-model="semester_id" default-value="0" style="width: 120px"
                            @change="handleChangesemester">
                            <a-select-option value="0">
                                全部学期
                            </a-select-option>
                            <a-select-option v-for="semester in semesterlist" :key="semester.id">
                                {{ semester.name }}
                            </a-select-option>
                        </a-select>
                        <a-tree class="white-space-wrap" :show-line=true :show-icon=true :defaultExpandAll=true
                            @select="selectchapterItem" :treeData=basicChapterList :replaceFields=replaceFields>
                            <a-icon slot="icon" type="carry-out" />
                        </a-tree>
                    </a-col>
                    <a-col :span="20">
                        <a-tabs v-model="tab">

                            <a-tab-pane key="1" tab="试卷">

                                <chapterTestpaper @testpaperkeys="addtestpaper"></chapterTestpaper>
                                <a-divider></a-divider>
                                <a-table :columns="columns" :data-source="chaptertestpaperlist"
                                    :pagination="testpaperpageinfo" @change="ontestpaperPaginationChange">
                                    <a slot="name" slot-scope="text">{{ text }}</a>
                                    {{ preview_bind_id }}
                                    <span slot="customTitle">
                                        <a-icon type="smile-o" /> Name</span>
                                    <span slot="action" slot-scope="text, record">
                                        <a-divider type="vertical" />
                                        <a @click="delltestpaper(record.id)">删除</a>
                                        <a-divider type="vertical" />
                                        <ViewExamModal :item="{ id: record.id }" />

                                        <ViewExamModal v-if="record.preview_bind_id != null" :item="{ id: record.bind_id }" />
                                        <!-- <a class="ant-dropdown-link" @click="showmal(record.id)">查看
                                            <a-icon type="down" />  </a>-->
                                    </span>
                                </a-table>



                            </a-tab-pane>

                        </a-tabs>
                    </a-col>
                </a-row>
            </div>

        </div>
    </or-layout>
</template>
<script>
import moment from "moment";
import ViewExamModal from '@/views/testpaper/view-examl.vue';
import chapterTestpaper from '@/views/basic/chapterTestpapermodel.vue';

//  import publishtestpaper from '@/views/orgpublish/publishtestpaper.vue';
const columns = [{
    title: '试卷名字',
    dataIndex: 'name',
    key: 'name',

},
{
    title: '试卷类型',
    dataIndex: 'typename',
    key: 'typename',

},
{
    title: '操作',
    key: 'action',
    scopedSlots: {
        customRender: 'action'
    },
},
];



export default {
    components: {
        ViewExamModal,
        chapterTestpaper,
    },

    data() {
        return {
            showLine: true,
            showIcon: false,
            chapter_id: '',
            basicChapterList: [],
            grade_id: 0,
            semester_id: 0,
            from: [],

            testpaper_id: '',
            islimit: 0,
            gradelist: [],
            semesterlist: [],
            testpaperpageinfo: {
                total: 1,
                current: 1,
                pageSize: 10,
                allCnt: 0
            },
            missionpageinfo: {
                total: 1,
                current: 1,
                pageSize: 10,
                allCnt: 0
            },
            missiontypelist: [],
            replaceFields: {
                children: 'children',
                title: 'name',
                key: 'id'
            },
            visible: false,
            missionvisible: false,
            xx: '',
            tab: '1',
            //  Testpaperdata,
            columns,
            mission_id: [],
            squad_ids: [],
            chaptertestpaperlist: [],
            chaptermissionlist: [],

        };
    },
    mounted() {
        this.getBasicChapter();
        this.getgrade();
        this.getsemester();
        // this.getChapterTestpaper();
    },
    methods: {
        addtestpaper(data) {
            if (this.chapter_id.length > 0) {
                this.$axios
                    .post("/api/BasicChapter/addchaptertestpaper", {
                        data: {
                            testpaper_ids: data,
                            chapter_id: this.chapter_id
                        }
                    }).then((res) => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                            this.getChapterTestpaper();
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            }
        },

        handleChangegrade(value) {
            this.grade_id = value
            this.getBasicChapter();
        },


        handleChangesemester(value) {
            this.semester_id = value
            this.getBasicChapter();
        },
        getgrade() {
            this.$axios
                .post("/api/BasicGrade/index")
                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                    } else {
                        this.gradelist = res.data.data;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });

        },
        getsemester() {
            this.$axios
                .post("/api/BasicSemester/index")
                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                    } else {
                        this.semesterlist = res.data.data;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        delltestpaper(testpaper_id) {
            let _this = this;
            this.$confirm({
                title: "删除试卷",
                content: "确认从本章节中移除该试卷吗?",
                okText: "确认",
                cancelText: "取消",
                onOk: function () {
                    _this.$axios
                        .post("/api/BasicChapter/dellchaptertestpaper", {
                            data: {
                                testpaper_id: testpaper_id,
                                chapter_id: _this.chapter_id
                            }
                        })
                        .then(res => {
                            if (res.code != 200) {
                                _this.$error({
                                    title: "错误",
                                    content: res.msg,
                                    okText: "确定"
                                });
                            } else {
                                _this.getChapterTestpaper();
                            }
                        })
                        .catch(err => {
                            console.error(err);
                        });
                }
            });



        },
        shengchengmission(id) {
            id;
            this.missionvisible = true;
        },
        ontestpaperPaginationChange(item) {
            this.testpaperpageinfo.current = item.current;
            this.getChapterTestpaper();
        },

        onmissionPaginationChange(item) {
            this.missionpageinfo.current = item.current;

        },
        selectchapterItem(selectedKeys, e) {
            e;
            if (selectedKeys[0] != null) {
                this.chapter_id = selectedKeys[0];
                this.getChapterTestpaper();

            }
        },

        showmal(id) {
            this.visible = true;
            this.testpaper_id = id;
            this.getgradelist();
            this.getmissiontypelist();
        },
        handleCancel() {
            this.visible = false;
        },
        handleCancelmission() {

            this.missionvisible = false;
        },
        okpostfrom() {
            this.postfrom();
            this.visible = false;
        },
        getBasicChapter() {
            this.$axios.post("/api/BasicChapter/gettreechapterbygrade", {
                data: {
                    'grade_id': this.grade_id,
                    'semester_id': this.semester_id,
                }

            })
                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                    } else {
                        this.basicChapterList = res.data;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });

        },
        // 获取试卷列表

        getChapterTestpaper() {
            // this.chaptertestpaperlist=null;
            this.$axios
                .post("/api/BasicChapter/getchaptertestpaper", {
                    data: {
                        chapter_id: this.chapter_id,
                    },
                    pageinfo: this.testpaperpageinfo,
                })
                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                    } else {
                        this.chaptertestpaperlist = res.data.data;
                        this.testpaperpageinfo = res.data.pageinfo;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        postfrom() {
            this.$axios
                .post("/api/BasicMission/orgaddmission", {
                    data: {
                        testpaper_id: this.testpaper_id,
                        mission_name: this.from.mission_name,
                        grade_id: this.from.grade_id,
                        start_time: this.from.start_time,
                        end_time: this.from.end_time,
                        islimit: this.islimit,
                        limit_time: this.from.limit_time,
                        type_id: this.from.type_id,
                        chapter_id: this.chapter_id,
                    },
                })
                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                    } else {
                        this.getChapterTestpaper();
                        this.getChapterMission();
                        this.tab = '2';


                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },

        getgradelist() {
            this.$axios
                .post("/api/BasicGrade/index", {

                })

                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                    } else {
                        this.gradelist = res.data.data;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },

        getmissiontypelist() {
            this.$axios
                .post("/api/BasicMissionType/index", {

                })

                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                    } else {
                        this.missiontypelist = res.data.data;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },

        /* onSelect(selectedKeys, info) {
             console.log('selected', selectedKeys, info);
         }, */
        moment
    },
};
</script>
<style>
.active_btn {
    margin-left: 5px;
}
</style>
